import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import { deleteDoctorOpdChargeRouter } from "services/doctorOPDChargeRouter";

const Delete = ({ item, onClose }) => {
  const { showAlert } = useAlert();
  const onSuccess = (res) => {
    const refetchBranches = true;
    showAlert("Doctor OPD Charge Router deleted successfully!", "danger");
    onClose(refetchBranches);
  };

  const onError = (err) => {
    const errorDetail = err?.response?.data?.detail;
    const message =
      typeof errorDetail === "string"
        ? errorDetail
        : errorDetail?.msg || JSON.stringify(errorDetail);

    showAlert(message, "danger");
  };

  const { mutate: deleteBranchMutate } = useMutation({
    mutationFn: deleteDoctorOpdChargeRouter,
    onSuccess,
    onError,
  });

  const onConfirm = () => {
    deleteBranchMutate(item);
  };
  return (
    <>
      <button type="button" className="btn btn-secondary" onClick={onClose}>
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-danger"
        onClick={() => {
          onConfirm();
        }}
      >
        Delete
      </button>
    </>
  );
};

export default Delete;
